module.exports = __webpack_public_path__ + "64e0aeba3f38771878894c26634114ca.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-CondBold.svg
 ** module id = 913
 ** module chunks = 9
 **/